module.exports = __webpack_public_path__ + "img/ic-whatsapp-green.4ce43579.svg";